<template>
    <div class="form">
        <!--步骤条-->
        <!--        <steps :active="active" :isUpload="isUpload" :emsNeeded="matterInfo.emsNeeded"></steps>-->
        <!--第一页（申报信息）-->
        <div v-show="active === 0">
            <!--公安机关选择-->
            <select-police :matterInfo="matterInfo" :declareInfo="baseInfoOne" ref="selectpolice"
                           :informationShowData="informationShowData"></select-police>
            <!--选择预约日期-->
            <van-field required readonly clickable label="预约日期" :value="appointDate" placeholder="请选择可预约日期"
                       @click="showPickerDate = true" @focus="getReservationDate" input-align="right" is-link/>
            <van-popup v-model="showPickerDate" position="bottom">
                <van-picker show-toolbar :columns="appointDateList" @cancel="showPickerDate = false"
                            value-key="title" @confirm="onConfirmDate"/>
            </van-popup>
            <!--选择预约时间-->
            <van-field required readonly clickable label="预约时间" :value="appointTime" placeholder="请选择可预约时间"
                       @click="showPickerTime = true" input-align="right" is-link/>
            <van-popup v-model="showPickerTime" position="bottom">
                <van-picker show-toolbar :columns="appointTimeList" @cancel="showPickerTime = false"
                            value-key="title" @confirm="onConfirmTime"/>
            </van-popup>
            <!--被探访人员信息-->
            <p class="title">被探访人员信息</p>
            <van-cell-group>
                <van-field v-model="baseInfo.form.visitee.visitee" required clearable label="姓名"
                           placeholder="请输入被探访人员姓名" input-align="right"/>
                <van-field v-model="baseInfo.form.visitee.visiteeId" required clearable label="身份证号码"
                           placeholder="请输入被探访人员身份证号码" input-align="right"/>
            </van-cell-group>
            <!--探访人员信息-->
            <p class="title">预约会见方式</p>
            <van-cell-group>
                <van-field required readonly clickable label="会见方式" v-model="baseInfo.form.handle.handle" placeholder="请选择"
                           @click="showPickerSex = true" input-align="right" is-link/>
                <van-popup v-model="showPickerSex" position="bottom">
                    <van-picker show-toolbar :columns="columns" value-key="name" @cancel="showPickerSex = false"
                                @confirm="onConfirm"/>
                </van-popup>
            </van-cell-group>
            <div class="btn-submit-div btn-submit-back">
                <!--                <van-button type="info" size="large" @click="next(1)">下一步</van-button>-->
                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>
            </div>
        </div>
        <!--第二页（附件上传）-->
        <div v-show="active === 1" v-if="isUpload">
            <p class="title">附件上传</p>
            <van-cell-group v-for="(item, index) in matterInfo.manifests" :key="index">
                <upload-image :title="item.itemName" :required="item.requred === 'Y'"
                              :uploadPath="`${path}?guid=${item.guid}&idx=${index}`"
                              :matId='item.guid' ref="imageChildFunction" :informationShowData="informationShowData"
                              @setImageInfo="getImageInfo"
                              @setIsImages="getIsImages"></upload-image>
            </van-cell-group>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" @click="up(0)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(2)">下一步</van-button>
            </div>
        </div>
        <!-- 第三页（办理方式）-->
        <div v-show="active === 2">
            <!--邮寄信息-->
            <mailing @setNextUpShow="getNextUpShow" :matterInfo="matterInfo" v-if="matterInfo.emsNeeded === 'Y'"
                     ref="mailingChildFunction"
                     @setMailingData="getMailingData"></mailing>
            <div class="btn-submit-div-double" v-if="nextUpShow">
                <van-button class="btn-left" type="info" size="large" @click="up(1)">上一步</van-button>
                <van-button class="btn-right" type="info" size="large" @click="next(3)">下一步</van-button>
            </div>
        </div>
        <!--第四页（提交确认）-->
        <div v-show="active === 3">
            <!--展示信息-->
            <information-show :informationShowData="informationShowData" @setActive="getActive"></information-show>
            <div class="btn-submit-div-double">
                <van-button class="btn-left" type="info" size="large" :matterInfo='matterInfo'
                            @click="matterInfo.emsNeeded === 'Y'?up(2):up(1)">上一步
                </van-button>
                <!--                <van-button class="btn-right" type="info" size="large" @click="submit">提交</van-button>-->
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 标准事项
     * Author: wangyan
     * Date: 2019-04-23
     * Time: 15:17
     */

    import {Button, Toast, Field, CellGroup, Dialog, Popup, Picker} from 'vant'
    import {matterApiMap} from '@/api/matter'
    import Steps from "@/components/declare/Steps"
    import SelectPolice from "@/components/declare/SelectPolice"
    import BasicInformation from "@/components/declare/BasicInformation"
    import UploadImage from "@/components/upload-image/UploadImage"
    import Mailing from "@/components/declare/Mailing"
    import InformationShow from "@/components/declare/InformationShow";
    import {reservationApiMap} from "@/api/reservation/index";
    import {idCardRegex} from "@/utils/regex";
    import {checkPhoneNum} from '@assets/js/api/Regular'

    export default {
        name: "AppointMatterTwo",
        components: {
            InformationShow,
            Mailing,
            UploadImage,
            Steps,
            SelectPolice,
            BasicInformation,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [Field.name]: Field,
            [CellGroup.name]: CellGroup,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                columns: ['提讯/询', '提解'],
                showPickerSex: false, // 是否显示方式选择框
                active: 0, // 控制步骤条当前位置
                matterInfo: {}, // 存放事项信息
                isUpload: false, // 判断是否有附件上传
                userInfo: {}, // 存放个人信息
                path: global.storageUrl + '/storage/upload', // 上传图片的地址
                isImagesList: [], // 存放每组上传图片是否已经上了
                nextUpShow: true, // 控制邮寄信息'上一页'和'下一页'显示与隐藏
                informationShowData: { // 展示信息
                    deptName: '', // 公安机关中文名（展示信息）
                    name: '', // 姓名（展示信息）
                    idNum: '', // 身份证（展示信息）
                    address: '', // 地址（展示信息）
                    phone: '', // 联系方式（展示信息）
                    isUpload: false, // 是否有附件上传状态（展示信息）
                    imageTitleList: [], // 附件标题列表（展示信息）
                    imageList: [], // 附件列表（展示信息）
                    mailingShow: '', // 是否有邮寄信息状态（展示信息）
                    mailingStatus: '', // 邮寄流程（展示信息）：1：办结送件，2：双程，3：上门取件
                    takeData: {}, // 取件信息（展示信息）
                    takePrice: '', // 取件费用（展示信息）
                    receiveData: {}, // 送件信息（展示信息）
                    receivePrice: '', // 送件费用（展示信息）
                    totalPrice: '' // 工本费（展示信息）
                },
                baseInfoOne: {
                    deptId: ''
                },
                baseInfo: {
                    //标准化事项
                    matid: this.$route.query.guid,
                    deptid: '', // 所选公安部门id
                    timeid: '',
                    orderday: '',
                    source: '1',
                    // tskSource: '0', // 申报来源(写死)
                    // matNum: '', // 事项编号
                    // accountId: '', //this.$cookie.getUser().acountId, // 注册的电话号码
                    // linkPhone: '', // 电话号码
                    // linkAddress: '', // 联系地址
                    // manifests: [], // 存放附件信息
                    // netProjectType: 'WEI',  // 申报方式(PCP|WIN|WEI|WAP|APP)
                    // isMailMertal: '', // 邮寄方式
                    // addressGuidQj: '', // 邮寄地址上门Guid
                    // addressGuidSh: '', // 邮寄地址送件Guid
                    // qjMoney: '', // 取件费
                    // shMoney: '', // 收件费用
                    // gbMoney: '', // 工本费
                    // emsConfig: '', // 邮寄流程：1：办结送件，2：双程，3：上门取件
                    // wfId: '', // 工作流id
                    form: {
                        //定制化事项
                        handle: {
                            handle: '',//会见方式
                        },
                        //被探访者信息
                        visitee: {
                            visitee: '', //被探访人员姓名
                            visiteeId: '', //被探访人员身份证号码
                        },
                    }
                },
                showPickerDate: false,
                showPickerTime: false,
                appointDate: '', //预约日期
                appointTime: '', //预约时间
                appointDateList: [], //预约日期集合
                appointTimeList: [], //预约时间集合
                appointList: [],
            }
        },
        mounted() {
            // 获取事项信息
            this.getMatterInfo()
            // 获取用户信息
            this.getUserInfo()
        },
        beforeRouteLeave(to, from, next) { // 对图片预览过程中，直接使用浏览器返回上一页，关闭图片预览
            for (let index in this.$refs.imageChildFunction) {
                this.$refs.imageChildFunction[index].closePreview()
            }
            next()
        },
        methods: {
            onConfirm(value) {
                console.log(value)
                this.baseInfo.form.handle.handle = value
                this.showPickerSex = false
                // Toast(`当前值：${value}, 当前索引：${index}`);
            },
            /**
             * 获取事项信息
             */
            async getMatterInfo() {
                try {
                    const res = await this.$httpUtils.getCommonUtils(`${matterApiMap.getMattersEtDetail}/${this.$route.query.guid}`)
                    this.matterInfo = res.data.data
                    // this.baseInfo.matNum = res.data.data.matNum
                    if (this.matterInfo.manifests.length) {
                        this.isUpload = true
                        this.informationShowData.isUpload = true
                        this.informationShowData.imageTitleList = this.matterInfo.manifests
                    }
                    // this.baseInfo.emsConfig = this.matterInfo.emsConfig
                    this.informationShowData.mailingShow = this.matterInfo.emsNeeded
                    // this.informationShowData.mailingStatus = this.matterInfo.emsConfig
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.baseInfo.isMailMertal = '101'
                    }
                    // this.baseInfo.wfId = this.matterInfo.wfId
                } catch (error) {
                    console.log(error)
                }
            },

            /**
             * 获取个人信息
             */
            async getUserInfo() {
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                    let province = this.userInfo.province === null || this.userInfo.province === undefined ? "" : this.userInfo.province
                    let city = this.userInfo.city === null || this.userInfo.city === undefined ? "" : this.userInfo.city
                    let area = this.userInfo.area === null || this.userInfo.area === undefined ? "" : this.userInfo.area
                    let address = this.userInfo.address === null ? "" : this.userInfo.address
                    let fullAddress = province.toString() + city.toString() + area.toString() + address.toString()
                    if (fullAddress === '0') {
                        fullAddress = ''
                    }
                    this.userInfo.fullAddress = fullAddress
                }
            },

            /**
             * 下一页
             * @param index 传入每一页下标
             */
            next(index) {
                Toast.clear()
                if (index === 1) { // 申报信息页面验证
                    this.$refs.selectpolice.setDeptId() // 部门赋值
                    if (!this.baseInfoOne.deptId) {
                        Toast('请选择公安机关')
                        return
                    }
                    //表单必输信息验证
                    if (!this.validateForm()) {
                        return
                    }
                    if (this.isUpload) { // 根据是否有上传附件判断进入'附件上传'或'办理方式'
                        this.active = 1
                    } else if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        this.active = 3
                    }
                } else if (index === 2) { // 附件上传页面验证
                    this.baseInfo.manifests = []
                    this.informationShowData.imageList = []
                    this.isImagesList = []
                    for (let index in this.$refs.imageChildFunction) { // 上传图片赋值
                        this.$refs.imageChildFunction[index].passImageValue()
                    }
                    for (let index in this.isImagesList) { // 判断必上传的图片是否上传
                        if (!this.isImagesList[index]) {
                            Toast('请选择上传附件')
                            return
                        }
                    }
                    if (this.matterInfo.emsNeeded === 'Y') {
                        this.active = 2
                    } else {
                        this.active = 3
                    }
                } else if (index === 3) {
                    this.$refs.mailingChildFunction.passMailingValue()
                    if ((this.baseInfo.emsConfig === '2' || this.baseInfo.emsConfig === '3') && !this.baseInfo.addressGuidQj) {
                        Toast('请添加地址')
                        return
                    }
                    if ((this.baseInfo.emsConfig === '2' || this.baseInfo.emsConfig === '1') && !this.baseInfo.addressGuidSh) {
                        Toast('请添加地址')
                        return
                    }
                    this.active = 3
                }
            },

            /**
             * 上一页
             * @param index 传入每一页下标
             */
            up(index) {
                if (index === 0) {
                    this.active = 0
                } else if (index === 1) {
                    this.active = 1
                } else if (index === 2) {
                    this.active = 2
                }
            },

            /**
             * 接收上传图片组件传来的image列表
             * @param value image列表
             */
            getImageInfo(value) {
                if (value.length > 0) {
                    for (let index in value) {
                        this.baseInfo.manifests.push(value[index])
                        this.informationShowData.imageList.push(value[index])
                    }
                }
            },

            /**
             * 接收是否上传图片的状态
             * @param value 是否上传了图片状态
             */
            getIsImages(value) {
                this.isImagesList.push(value)
            },

            /**
             * 接收邮寄信息组件传来的是否展示邮寄信息的'上一页'和'下一页'的状态
             * @param value 布尔值
             */
            getNextUpShow(value) {
                this.nextUpShow = value
            },

            /**
             * 接收邮寄信息组件
             * @param value 布尔值
             */
            getMailingData(value) {
                this.baseInfo.addressGuidQj = value.addressGuidQj
                this.baseInfo.addressGuidSh = value.addressGuidSh
                this.baseInfo.qjMoney = value.qjMoney
                this.baseInfo.shMoney = value.shMoney
                this.baseInfo.gbMoney = value.gbMoney
                this.informationShowData.takeData = value.takeData
                this.informationShowData.takePrice = value.qjMoney
                this.informationShowData.receiveData = value.receiveData
                this.informationShowData.receivePrice = value.shMoney
                this.informationShowData.totalPrice = value.gbMoney
            },

            /**
             * 接收事项信息展示组件传来的值，改变active参数
             * @param value 传来的下标，改变active参数
             */
            getActive(value) {
                this.active = value
            },

            //格式化数据
            formatterSubmit() {
                const dataBak = Object.assign({}, this.baseInfo);
                return dataBak;
            },

            /**
             * 提交时，需要把标准化事项和定制化事项的两个数据对象合并
             * @return {Promise<void>}
             */
            async submit() {
                this.$refs.selectpolice.setDeptId() // 部门赋值
                if (!this.baseInfoOne.deptId) {
                    Toast('请选择公安机关')
                    return
                }
                //表单必输信息验证
                if (!this.validateForm()) {
                    return
                }
                const dataBak = this.formatterSubmit();
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '提交中...'
                })
                try {
                    const res = await this.$httpUtils.postGatewayUtils(reservationApiMap.handleMatter, dataBak)
                    if (res.data.succ) {
                        Toast.clear()
                        Dialog.alert({
                            title: '预约成功,您可点击下方菜单项中我的-我的预约查看预约事项',
                            message: `您的办件编号为:${res.data.data}`
                        }).then(() => {
                            this.$router.push('/matterList')
                        })
                    } else if (res.data.code == 11001) {
                        Toast.clear()
                        Dialog.alert({
                            title: '预约失败',
                            message: "当前时间段预约人数已满"
                        })
                    } else {
                        Toast.clear()
                        Dialog.alert({
                            title: '预约失败',
                            message: res.data.msg,
                        })
                    }
                } catch (error) {
                    Toast.clear()
                    Dialog.alert({
                        title: '预约失败！',
                        message: '服务器好像有点问题，请稍后重试!'
                    })
                }
            },

            /**
             * 选择预约日期
             */
            onConfirmDate(value) {
                if(value.title){
                    this.appointDate = value.title;
                    this.baseInfo.orderday = value.val;
                }

                this.showPickerDate = false;
                this.appointTime = '';
            },
            /**
             * 选择预约时间
             */
            onConfirmTime(value) {
                if(value.title){
                    this.appointTime = value.title;
                    this.baseInfo.timeid = value.val;
                }

                this.showPickerTime = false;
            },
            /**
             * 验证表单必输数据
             */
            validateForm() {
                if (this.appointDate === '') {
                    Toast("请选择预约日期")
                    return false
                }
                if (this.appointTime === '') {
                    Toast("请选择预约时间")
                    return false
                }
                if (this.baseInfo.form.visitee.visitee === '') {
                    Toast("请输入被探访人员姓名")
                    return false
                }
                if (this.baseInfo.form.visitee.visiteeId === '') {
                    Toast("请输入被探访人员身份证号码")
                    return false
                }
                if (!idCardRegex(this.baseInfo.form.visitee.visiteeId)) {
                    Toast("请输入正确的身份证号码")
                    return false
                }
                if (this.baseInfo.form.handle.handle === '') {
                    Toast("请选择会见方式")
                    return false
                }
                return true
            },
            /**
             *  获取律师编号
             */
            getLawyer() {
                if (this.baseInfo.form.lawyer.lawyerWorkNum.length == '17') {
                    this.$httpUtils.getCommonUtils(`${reservationApiMap.queryLawyer}/${this.baseInfo.form.lawyer.lawyerWorkNum}`).then(response => {
                        if (response.data.succ = true) {
                            const d = response.data.data;
                            const lawerUnit = d.lawOfficeName
                            const lawerName = d.userName
                            this.baseInfo.form.lawyer.lawyerCompany = lawerUnit
                            this.baseInfo.form.lawyer.lawyer = lawerName
                        }
                    }).catch(err => {
                        Toast("暂未获取到律师信息！")
                    })
                } else {
                    Toast("请输入正确的律师证号！")
                }

            },

            /**
             * 预约日期,时间
             */
            getReservationDate() {
                this.$refs.selectpolice.setDeptId()
                if (!this.baseInfoOne.deptId) {
                    Toast('请选择公安机关')
                } else {
                    this.$httpUtils.getCommonUtils(`${reservationApiMap.getReservationDate}/${this.baseInfoOne.deptId}/${this.baseInfo.matid}`).then(response => {
                        this.baseInfo.deptid = this.baseInfoOne.deptId;
                        let arr = [];
                        let timeLines = '';
                        let timeList = [];
                        if (response.data.succ = true) {
                            const d = response.data.data;
                            for (var i = 0; i < d.length; i++) {
                                arr.push({"title": d[i].date, "val": d[i].guid})
                                timeLines = d[i].timelines;
                            }
                            for (var j = 0; j < timeLines.length; j++) {
                                timeList.push({
                                    "title": timeLines[j].sTime + "-" + timeLines[j].eTime,
                                    "val": timeLines[j].guid
                                });
                            }
                        }
                        this.$nextTick(() => {
                            this.appointDateList = arr;
                            this.appointTimeList = timeList;
                        })

                    }).catch(err => {
                    })
                }

            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/matter/declare/standard-matter/StandardMatter.less";
</style>
